import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CustomAlert from "../../shared/CustemAlert";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter }) {
  const [title, setTitle] = useState(""); // useState hook
  const [details, setDetails] = useState("");
  const [error, setError] = useState(false);
  const [isAdded, SetIsAdded] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  // handle change event
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    if (e.target.id === "title") setTitle(e.target.value);
    else setDetails(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isMounted = true;
    const controller = new AbortController();

    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/ptorreason/",
          {
            title: title.trim(),
            details: details.trim(),
          },
          {
            signal: controller.signal,
          }
        );
        setDetails("");
        SetIsAdded(true);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
    setTitle("");
    setError(false);
  };
  // render

  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3 border  ">
          <div className="card-header">
            <h2>סיבות לפטור</h2>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="title">סיבה</label>
                    <input
                      type="text"
                      name="title"
                      value={title}
                      onChange={handleChange}
                      className="form-control"
                      id="title"
                      placeholder="תקליד סיבה להוספה"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="details">פירוט</label>
                    <textarea
                      rows="4"
                      cols="50"
                      name="details"
                      value={details}
                      onChange={handleChange}
                      className="form-control"
                      id="details"
                      placeholder="פירוט"
                    />
                  </div>
                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף סיבה חדשה
                  </button>
                </form>
              </Col>
            </Row>

            {isAdded && (
              <CustomAlert
                setShow={SetIsAdded}
                alertHeader={title}
                alertBody="הסיבה נוספה בהצלחה"
              />
            )}
          </div>
        </div>
      </center>
    </div>
  );
}
